import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
    useRoutes,
    getPageName,
    goQuitterParcours
} from '../../hooks/navigation/useRoutes/useRoutes';
import { useTranslation } from 'react-i18next';
import { NavigationPlacement, SaveAndLeaveModal } from '../../components';
import { Button, ButtonVariant } from '../../styles';
import {
    sendEvent,
    EVENT_CATEGORIES,
    EVENT_ACTIONS,
    EVENT_LABELS
} from '../../features';

interface EveilAssuranceNavigationProps {
    onContinuerSansAssuranceClick: () => void;
    onBasculerAssuranceClick: () => void;
}

export const Navigation: React.FC<EveilAssuranceNavigationProps> = ({
    onContinuerSansAssuranceClick,
    onBasculerAssuranceClick
}) => {
    const [t] = useTranslation(['EveilAssurance']);
    const dispatch = useDispatch();
    const { getRoute, goToRoute } = useRoutes();

    // Api

    // Confirmation modal
    const [isModalOpened, setIsModalOpened] = useState(false);

    // Send cyber & leave
    const leaveApp = () => {
        const pageCourante = getPageName();

        if (pageCourante) {
            dispatch(
                sendEvent({
                    category: EVENT_CATEGORIES.RHN,
                    action: EVENT_ACTIONS.CLIC,
                    label: EVENT_LABELS.ENREGISTRER_ET_QUITTER + pageCourante
                })
            );
        }

        goQuitterParcours();
    };

    const handleCancel = () => {
        // Open confirmation modal
        setIsModalOpened(true);
    };

    const handleClicModalClose = (shouldStayHere: boolean) => {
        // Close confirmation modal
        setIsModalOpened(false);
        if (!shouldStayHere) {
            // Send cyber & leave
            leaveApp();
        }
    };

    const handleBack = () => {
        dispatch(
            sendEvent({
                category: EVENT_CATEGORIES.RHN,
                action: EVENT_ACTIONS.CLIC,
                label: EVENT_LABELS.PRECEDENT + getPageName()
            })
        );
        goToRoute(getRoute().prevRoute);
    };

    const handleNext = () => {
        onContinuerSansAssuranceClick();
    };

    return (
        <>
            <SaveAndLeaveModal
                isOpen={isModalOpened}
                onNext={() => handleClicModalClose(false)}
                onCancel={() => handleClicModalClose(true)}
            />
            <NavigationPlacement
                renderNextButton={
                    <Button
                        variant={ButtonVariant.primary}
                        dataCy="qa-button-assurance-basculer"
                        dataTestId={'navigation-next-assurance-button'}
                        onClick={onBasculerAssuranceClick}
                        fullWidth="xs"
                    >
                        {t('nextWithInsuranceButton')}
                    </Button>
                }
                renderNextButtonAlt={
                    <Button
                        id={'QA_test_navigation_next_button'}
                        variant={ButtonVariant.secondary}
                        dataCy="qa-navigation-button-next"
                        dataTestId={'navigation-next-button'}
                        onClick={handleNext}
                        fullWidth="xs"
                    >
                        {t('nextWithNoInsuranceButton')}
                    </Button>
                }
                renderBackButton={
                    <Button
                        id={'QA_test_navigation_back_button'}
                        variant={ButtonVariant.secondary}
                        dataCy="qa-navigation-button-back"
                        dataTestId={'navigation-back-button'}
                        onClick={handleBack}
                        fullWidth="xs"
                    >
                        {t('backButton')}
                    </Button>
                }
                renderSaveButton={
                    <Button
                        id={'QA_test_navigation_quit_button'}
                        variant={ButtonVariant.secondary}
                        dataCy="qa-navigation-button-quit"
                        dataTestId={'navigation-quit-button'}
                        onClick={handleCancel}
                        fullWidth="xs"
                    >
                        {t('cancelButton')}
                    </Button>
                }
            />
        </>
    );
};
